// extracted by mini-css-extract-plugin
export var dividerLine = "_7p-3";
export var itemImage = "_7p-9";
export var lightDivider = "_7p-4";
export var modalContent = "_7p-5";
export var modalContentCompact = "_7p-6";
export var productCard = "_7p-a";
export var productImage = "_7p-b";
export var productImageCompact = "_7p-7";
export var productImagePlaceholder = "_7p-c";
export var productImagePlaceholderCompact = "_7p-8";
export var progressBarBackground = "_7p-1";
export var progressBarContainer = "_7p-0";
export var progressBarFill = "_7p-2";